import React from "react";
import { useDocumentMeta } from "./hooks/useDocumentMeta";
import { SiteHeader } from "./components/SiteHeader";
import { SiteFooter } from "./components/SiteFooter";
import { MiniLeadForm } from "./components/MiniLeadForm";

const Privacy = () => {
  useDocumentMeta({
    title: "Privacy Policy | PickQuick",
    description:
      "How PickQuick collects, uses, stores and deletes the information you share via letspickquick.com forms and our WhatsApp lead capture, plus your data deletion rights.",
    ogType: "website",
    ogUrl: "https://letspickquick.com/privacy",
    canonical: "https://letspickquick.com/privacy",
  });

  return (
    <div className="min-h-screen flex flex-col" style={{ background: "var(--bg-deep)", color: "#FFFFFF" }}>
      <SiteHeader />

      <main className="flex-1 py-24" data-testid="privacy-page">
        <div className="container" style={{ maxWidth: "780px" }}>
          <h1 style={{ fontSize: "44px", fontWeight: 700, lineHeight: 1.15, letterSpacing: "-0.02em", marginBottom: "16px" }}>
            Privacy Policy
          </h1>
          <p style={{ color: "#8A8A8A", fontSize: "14px", marginBottom: "48px" }}>
            Last updated: April 2026
          </p>

          <div style={{ color: "#B8B8B8", fontSize: "16px", lineHeight: 1.7 }}>
            <p style={{ marginBottom: "24px" }}>
              This policy explains what information PickQuick (operated by Kutwal Foods Pvt. Ltd. affiliate entity) collects when you interact with our website letspickquick.com or our WhatsApp lead capture channel, and how we handle it.
            </p>

            <h2 style={{ fontSize: "22px", fontWeight: 600, color: "#FFFFFF", marginTop: "40px", marginBottom: "12px" }}>What we collect</h2>
            <p style={{ marginBottom: "16px" }}>
              When you submit a lead form on our website, or start a conversation via our WhatsApp lead capture link, we collect the information you choose to share with us. This can include:
            </p>
            <ul style={{ paddingLeft: "24px", marginBottom: "24px", listStyleType: "disc" }}>
              <li style={{ marginBottom: "8px" }}>Your name</li>
              <li style={{ marginBottom: "8px" }}>Your email address</li>
              <li style={{ marginBottom: "8px" }}>Your phone number, including country code</li>
              <li style={{ marginBottom: "8px" }}>Your brand or company name</li>
              <li style={{ marginBottom: "8px" }}>Your city or region of operation</li>
              <li style={{ marginBottom: "8px" }}>Your product category</li>
              <li style={{ marginBottom: "8px" }}>Your monthly GMV or sales band</li>
              <li style={{ marginBottom: "8px" }}>Any free-text context you provide about your business or goals</li>
            </ul>

            <h2 style={{ fontSize: "22px", fontWeight: 600, color: "#FFFFFF", marginTop: "40px", marginBottom: "12px" }}>Why we collect it</h2>
            <p style={{ marginBottom: "24px" }}>
              We use the information you share solely to respond to your business enquiry and to evaluate whether your brand is a fit for the Quick Commerce enablement, consulting, or platform services we offer. We do not use it for advertising or profiling.
            </p>

            <h2 style={{ fontSize: "22px", fontWeight: 600, color: "#FFFFFF", marginTop: "40px", marginBottom: "12px" }}>Who sees it</h2>
            <p style={{ marginBottom: "16px" }}>
              Your information is stored on systems operated by PickQuick and its infrastructure partners. It is shared only with our internal team members who need to see it to respond to your enquiry.
            </p>
            <p style={{ marginBottom: "24px" }}>
              We do not sell your data to third parties. We do not share it with advertisers, data brokers, or unrelated businesses.
            </p>

            <h2 style={{ fontSize: "22px", fontWeight: 600, color: "#FFFFFF", marginTop: "40px", marginBottom: "12px" }}>How long we keep it</h2>
            <p style={{ marginBottom: "24px" }}>
              We retain your submission for as long as it is useful to our commercial relationship, or up to 36 months from the date of your last interaction with us, whichever is shorter. After that, records are deleted or anonymised.
            </p>

            <h2 style={{ fontSize: "22px", fontWeight: 600, color: "#FFFFFF", marginTop: "40px", marginBottom: "12px" }}>Deletion requests</h2>
            <p style={{ marginBottom: "16px" }}>
              You can ask us to delete any information you have shared with us at any time. Email:
            </p>
            <p style={{ marginBottom: "24px" }}>
              <a href="mailto:anuj@letspickquick.com" style={{ color: "#F1592B" }}>anuj@letspickquick.com</a>
            </p>
            <p style={{ marginBottom: "24px" }}>
              We will action deletion requests within 30 days.
            </p>
          </div>
        </div>
      </main>

      <section className="pb-16" style={{ backgroundColor: "var(--bg-deep)" }}>
        <div className="container" style={{ maxWidth: "1080px" }}>
          <MiniLeadForm
            source="privacy-mini"
            variant="band"
            pagePath="/privacy"
            headline="Talk to us about your Quick Commerce data."
            subhead="Free QC audit. One platform, one category, no cost. We open WhatsApp with your details pre-filled."
          />
        </div>
      </section>

      <SiteFooter />
    </div>
  );
};

export default Privacy;
